(() => {
  for (const root of document.querySelectorAll('[data-pb26]')) {
    if (root.dataset.initialized) continue;
    const data = JSON.parse(root.querySelector('[data-pb26-data]').textContent);
    const form = root.querySelector('form');
    const variantSelect = root.querySelector('[data-pb26-variant]');
    const quantity = form.elements.quantity;
    const addButton = root.querySelector('[data-pb26-add]');
    const status = root.querySelector('[data-pb26-status]');
    const cartNext = root.querySelector('[data-pb26-cart-next]');
    let busy = false;
    const formatter = new Intl.NumberFormat(document.documentElement.lang || 'en-GB', { style: 'currency', currency: data.currency });
    const format = amount => `${formatter.format(amount / 100)} ${data.currency}`;
    const selectedSet = () => root.querySelector('[name="pb26-set"]:checked')?.value || 'Hands Only';
    const selectedSize = () => root.querySelector('[name="pb26-size"]:checked')?.value;
    const currentVariant = () => data.variants.find(variant => variant.options[0] === selectedSet() && variant.options[1] === selectedSize());
    const update = () => {
      const variant = currentVariant();
      const displayed = variant || data.variants.find(item => item.options[0] === selectedSet());
      variantSelect.value = variant ? String(variant.id) : '';
      root.querySelector('[data-pb26-price]').textContent = displayed.money;
      root.querySelector('[data-pb26-sticky-price]').textContent = displayed.money;
      root.querySelector('[data-pb26-total]').textContent = format(displayed.price * (quantity.valueAsNumber || 1));
      root.querySelector('[data-pb26-set-copy]').textContent = `${selectedSet() === 'Hands Only' ? '10 hand nails' : '10 hand + 10 toe nails'} · ${selectedSize() || 'choose your size below'}`;
      addButton.disabled = busy || Boolean(variant && !variant.available);
      addButton.innerHTML = variant && !variant.available ? 'Sold out' : 'Add to bag <span>↗</span>';
      status.textContent = '';
      status.removeAttribute('data-error');
      cartNext.hidden = true;
      if (variant) {
        const url = new URL(location.href);
        url.searchParams.set('variant', variant.id);
        history.replaceState({}, '', url);
      }
    };
    const showFit = () => { root.querySelector('[data-pb26-fit-details]').open = true; };
    root.querySelector('[data-pb26-fit-link]').addEventListener('click', showFit);
    for (const link of root.querySelectorAll('[data-pb26-choose]')) {
      link.addEventListener('click', () => {
        for (const radio of root.querySelectorAll('[name="pb26-set"]')) radio.checked = radio.value === link.dataset.pb26Choose;
        update();
      });
    }
    for (const radio of root.querySelectorAll('[name="pb26-set"], [name="pb26-size"]')) radio.addEventListener('change', update);
    quantity.addEventListener('input', update);
    root.querySelector('[data-pb26-minus]').addEventListener('click', () => { quantity.value = Math.max(1, (quantity.valueAsNumber || 1) - 1); update(); });
    root.querySelector('[data-pb26-plus]').addEventListener('click', () => { quantity.value = Math.min(99, (quantity.valueAsNumber || 1) + 1); update(); });
    form.noValidate = true;
    form.addEventListener('submit', async event => {
      event.preventDefault();
      if (busy) return;
      const variant = currentVariant();
      if (!variant) {
        status.textContent = 'Please choose your hand size before adding to bag.';
        status.dataset.error = 'true';
        root.querySelector('[name="pb26-size"]').focus();
        return;
      }
      if (!variant.available || !quantity.checkValidity() || !Number.isInteger(quantity.valueAsNumber)) {
        status.textContent = variant.available ? 'Please enter a whole quantity from 1 to 99.' : 'This combination is unavailable. Please choose another size.';
        status.dataset.error = 'true';
        quantity.reportValidity();
        return;
      }
      busy = true;
      addButton.disabled = true;
      addButton.textContent = 'Adding…';
      status.textContent = '';
      cartNext.hidden = true;
      const requestedQuantity = quantity.valueAsNumber;
      try {
        const base = root.dataset.rootUrl.endsWith('/') ? root.dataset.rootUrl : `${root.dataset.rootUrl}/`;
        const response = await fetch(`${base}cart/add.js`, {
          method: 'POST', headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: variant.id, quantity: requestedQuantity }] })
        });
        const result = await response.json();
        if (!response.ok) throw new Error(result.description || result.message || 'Could not add this set. Please try again.');
        status.removeAttribute('data-error');
        status.textContent = `${requestedQuantity} × ${variant.title} added to your bag.`;
        cartNext.hidden = false;
        document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { source: 'poolside-launch' } }));
      } catch (error) {
        status.dataset.error = 'true';
        status.textContent = `${error.message || 'A connection issue prevented confirmation.'} If your connection dropped, check your bag before trying again.`;
      } finally {
        busy = false;
        addButton.disabled = false;
        addButton.innerHTML = 'Add to bag <span>↗</span>';
      }
    });
    const requestedVariant = data.variants.find(variant => String(variant.id) === new URL(location.href).searchParams.get('variant'));
    if (requestedVariant) {
      for (const radio of root.querySelectorAll('[name="pb26-set"]')) radio.checked = radio.value === requestedVariant.options[0];
      for (const radio of root.querySelectorAll('[name="pb26-size"]')) radio.checked = radio.value === requestedVariant.options[1];
    }
    const sticky = root.querySelector('[data-pb26-sticky]');
    const observer = new IntersectionObserver(entries => {
      sticky.classList.toggle('is-visible', !entries[0].isIntersecting && root.querySelector('.pb26-buy').getBoundingClientRect().bottom < 0);
    }, { threshold: 0 });
    observer.observe(root.querySelector('.pb26-buy'));
    root.dataset.initialized = 'true';
    root.classList.add('pb26--ready');
    update();
  }
})();
